import React from "react";
import clg from "./log";

export const formatFloor = ( floor ) => {
    const floors = {
        "0" : "Földszint",
    }

    if( floors.hasOwnProperty( floor ) ) {
        return floors[ floor ];
    }
    return floor;
}

export const formatRoomType = ( roomNo, key = null ) => {
    let _roomNo = roomNo;

    if( typeof _roomNo !== "int" ) {
        _roomNo = parseInt( _roomNo );
    }

    //clg("FORMAT ROOM TYPE: ", _roomNo)

    const roomNumToType = {
        1 : {
            title : "Egyszobás stúdiólakás",
            description : <div className="apartment-description"><span>Egy szobás, kiválóan bútorozható lakás, 25m<sup>2</sup>-es nappalival, amely magában foglalja a konyhát, étkezőt valamint az alvóteret is, amely stílus rendkívül modern és fiatalos.</span><span>Hatalmas ablakainak köszönhetően kifejezetten világos, ezen kívül kis erkély tartozik hozzá, amely közel 5m<sup>2</sup>-es, a nappaliból megközelíthető.</span><span>Az előtérből nyílik a fürdő és a WC, amely lakásaink zömében egy légtérben található.</span></div>
        },
        2 : {
            title : "Kétszobás lakás",
            description : <div className="apartment-description"><span>A hálószobával kiegészített, nappalis lakás tökéletes, ha szükséged van egy <b>közösségi térre</b>, ugyannakkor néha visszavonulnál.</span><span>Számos 2 szobás lakásunk <b>gardróbbal</b> kiegészített, hogy a pakolás miatt se fájjon a fejünk.</span><span> A közel 20 m<sup>2</sup>-es, kényelmes nappalin felül a konyha és az étkező is egy légtérben található. Ebből a helyiségből tudunk kimenni a nagy méretű, <b>jól</b> bútorozható teraszunkra - ha ilyen lakást választunk -, amely kellemes hangulatot biztosít egy baráti beszélgetéshez vagy egy kellemes könyvhöz.</span></div>
        },
        3 : {
            title : "Családi otthon",
            description : <div className="apartment-description"><span>Igazán <b>komfortos</b>, nagy terekkel ellátott 2 hálószobás, nappalis lakásaink ideálisak abban az esetben, ha <b>családdal</b> költözik az ember, de a plusz szoba akár <b>dolgozószobaként</b> is tökéletesen funkcionál.</span><span>Ezen lakástípusban a legtöbb esetben <b>gardrób</b> is található, továbbá az előtérből külön helyiségben találjuk a fürdőszobát és a WC-t is.</span></div>
        },
        4 : {
            title : "Családi otthon",
            description : <div className="apartment-description"><span>Neked kínáljuk legnagyobb lakásunkat, ha <b>óriási terekre</b> vágysz, kényelmesen szeretnél élni.</span><span>A hatalmas nappalin felül lehet akár három hálószobád, gyerköcőknek külön szoba, esetleg berendezhetsz egy dolgozószobát, ahová bármikor elvonulhatsz, ha nyugalomra vágysz.</span><span>Természetesen egy <b>gardrób</b> is remek döntés, amennyiben igényed van rá, ígérjük, hogy tökéletesen kielégíti majd igényeidet. Ezen felül hatalmas fürdőszoba és mosdó is megtalálható jövendőbeli otthonodban, amelyben egy hosszú fáradt nap után relaxálhatsz.</span></div>
        }
    }

    if( roomNumToType.hasOwnProperty( roomNo ) ) {
        if( key ) {
            if( roomNumToType[ roomNo ].hasOwnProperty( key ) ) {
                return roomNumToType[ roomNo ][ key ];
            }
        }

        return roomNumToType[ roomNo ]
    }
}

export const formatRoom = ( roomNo ) => {

    let _roomNo = roomNo;

    if( typeof _roomNo !== "int" ) {
        _roomNo = parseInt( _roomNo );
    }

    const rooms = {
        0 : {
             name : "Nappali",
             icon : "c-icon-living-room",
        },

        1 : { 
            name : "Szoba",
            icon : "c-icon-room",
        },

        2 : { 
            name : "Konyha",
            icon : "c-icon-kitchen",
        },

        3 : { 
            name : "Étkező",
            icon : "c-icon-dining-room",
        },

        4 : { 
            name : "Fürdő, WC",
            icon : "c-icon-bathroom-with-toilet",
        },

        5 : { 
            name : "Fürdő",
            icon : "c-icon-bathroom",
        },

        6 : { 
            name : "WC",
            icon : "c-icon-toilet",
        },

        7 : { 
            name : "Előtér",
            icon : "c-icon-lobby",
        },

        8 : { 
            name : "Gardrób",
            icon : "c-icon-wardrobe",
        },

        9 : { 
            name : "Közlekedő",
            icon : "c-icon-approaching",
        },

        10 : { 
            name : "Terasz",
            icon : "c-icon-terrace",
        },

        11 : { 
            name : "Erkély",
            icon : "c-icon-balcony",
        },

        12 : { 
            name : "Magánkert",
            icon : "c-icon-garden",
        },

        13 : { 
            name : "Loggia",
            icon : "c-icon-loggia",
        },
    }

    if( rooms.hasOwnProperty( _roomNo ) ) {
        return rooms[ _roomNo ]
    }
}

export const formatStatus = ( statusNo, key = null ) => {

    let _statusNo = statusNo;

    if( typeof _statusNo !== "int" ) {
        _statusNo = parseInt( _statusNo );
    }

    const statuses = {
       0 : {
            value : 0,
            name : "Eladó",
            class : "for-sale",
       }, 

       1 : {
            value : 1,
            name : "Foglalt",
            class : "reserved"
       },

       2 : {
            value : 2,
            name : "Értékesített",
            class : "sold"
       },

       3 : {
            value : 3,
            name : "Kiadó",
            class : "for-rent"
       } 
    }

    if( statuses.hasOwnProperty( _statusNo ) ) {
        if( key ) {
            if( statuses[ _statusNo ].hasOwnProperty( key ) ) {
                return statuses[ _statusNo ][ key ];
            }
        }

        return statuses[ _statusNo ]
    }
}

export const formatOrientation = ( orientation, key = null ) => {

    const orientations = {
        N : {
            value : "N",
            label : "Észak",
        },

        S : {
            value : "S",
            label : "Dél",
        },

        E : {
            value : "E",
            label : "Kelet",
        },

        W : {
            value : "W",
            label : "Nyugat",
        },
    }

    if( orientations.hasOwnProperty( orientation ) ) {
        if( key ) {
            if( orientations[ orientation ].hasOwnProperty( key ) ) {
                return orientations[ orientation ][ key ];
            }
        }

        return orientations[ orientation ]
    }

}

export const formatMoney = ( value, postfix = null ) => {

    let formatted = new Intl.NumberFormat('hu-HU', {
        style: 'currency',
        currency: 'HUF',
      }).format(value).replace("Ft","").split(",")[0];

    if( postfix ) return formatted + postfix;

    return formatted;
}